import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LOGIN_AUTH, LoginAuth } from './login.tokens';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  signInFailed = false;
  returnUrl = '/';

  constructor(
    @Inject(LOGIN_AUTH) private authService: LoginAuth,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.signInFailed = this.route.snapshot.queryParamMap.get('sso') === 'checked';
    this.returnUrl = this.route.snapshot.queryParamMap.get('returnUrl') || '/';
  }

  signIn(): void {
    this.authService.beginSso(this.returnUrl);
  }

}
